'use strict';

define(['events/events', 'events/states', 'utils/backbone.events', 'utils/helpers', 'utils/timer', 'utils/underscore', 'controller/controller', 'api/api-actions', 'api/api-mutators', 'api/callbacks-deprecate', 'baidu/log', 'version'], function (events, states, Events, utils, Timer, _, Controller, actionsInit, mutatorsInit, legacyInit, Log, version) {

    var Api = function Api(container, globalRemovePlayer) {
        var _this = this,
            _controller,
            _playerReady = false,
            _itemMeta = {};

        // Set up event handling
        _.extend(this, Events);

        // This helps plugins, particularly analytics
        this.utils = utils;
        this._ = _;
        this.Events = Events;
        this.version = version;

        this.trigger = function (type, args) {
            if (_.isObject(args)) {
                args = _.extend({}, args);
            } else {
                args = {};
            }
            args.type = type;
            if (window.jwplayer && window.jwplayer.debug) {
                return Events.trigger.call(_this, type, args);
            }
            return Events.triggerSafe.call(_this, type, args);
        };

        // Required by vast
        // <deprecate>
        this.dispatchEvent = this.trigger;
        this.removeEventListener = this.off.bind(this);
        // </deprecate>

        var _setupController = function _setupController() {
            _controller = new Controller(container);

            // Add a bunch of methods
            actionsInit(_this, _controller);
            mutatorsInit(_this, _controller);
            _controller.on(events.JWPLAYER_PLAYLIST_ITEM, function () {
                _itemMeta = {};
            });
            _controller.on(events.JWPLAYER_MEDIA_META, function (data) {
                _.extend(_itemMeta, data);
            });

            // capture the ready event and add setup time to it
            _controller.on(events.JWPLAYER_READY, function (event) {
                _playerReady = true;
                _qoe.tick('ready');
                event.setupTime = _qoe.between('setup', 'ready');

                // 视频加载完成后再去进行百度用户鉴权 zhangzhe 2015-12-23改
                var log = new Log(_this.getConfig(), _this);
                log.userCertify();
                /*
                // 为iphone部分浏览器内联播放而设置
                var video = document.querySelector('video');
                if (video) {
                    enableInlineVideo(video);
                }
                */
            });
            _controller.on('all', _this.trigger);

            _controller.on(events.JWPLAYER_ERROR, function (evt) {
                // 如果某些mp4文件不能用video播放，则用flash播放看看
                if (evt.type === 'mediaError' && utils.isMp4(evt.videoSrc) && evt.detail && (evt.detail.message === 'DEMUXER_ERROR_COULD_NOT_OPEN: FFmpegDemuxer: open context failed' || evt.detail.code === 4)) {
                    var options = _this.getConfig().options;
                    options.primary = 'justflash';
                    // 重新加载一下flash
                    _controller.setup(options, _this);
                }
            });
        };
        _setupController();
        legacyInit(this);

        // These should be read-only model properties
        this.id = container.id;

        // Intialize QOE timer
        var _qoe = this._qoe = new Timer();
        _qoe.tick('init');

        var _reset = function _reset() {
            _playerReady = false;
            _itemMeta = {};

            _this.off();

            if (_controller) {
                _controller.off();
            }

            // so players can be removed before loading completes
            if (_controller && _controller.playerDestroy) {
                _controller.playerDestroy();
            }
        };

        this.getPlugin = function (name) {
            return _this.plugins && _this.plugins[name];
        };

        this.addPlugin = function (name, pluginInstance) {
            this.plugins = this.plugins || {};
            this.plugins[name] = pluginInstance;

            this.onReady(pluginInstance.addToPlayer);

            // A swf plugin may rely on resize events
            if (pluginInstance.resize) {
                this.onResize(pluginInstance.resizeHandler);
            }
        };

        this.setup = function (options) {
            _qoe.tick('setup');

            _reset();
            _setupController();

            // bind event listeners passed in to the config
            utils.foreach(options.events, function (evt, val) {
                var fn = _this[evt];
                if (typeof fn === 'function') {
                    fn.call(_this, val);
                }
            });

            options.id = _this.id;
            _controller.setup(options, this);

            return _this;
        };

        this.qoe = function () {
            var qoeItem = _controller.getItemQoe();

            var setupTime = _qoe.between('setup', 'ready');
            var firstFrame = qoeItem.between(events.JWPLAYER_MEDIA_PLAY_ATTEMPT, events.JWPLAYER_MEDIA_FIRST_FRAME);

            return {
                setupTime: setupTime,
                firstFrame: firstFrame,
                player: _qoe.dump(),
                item: qoeItem.dump()
            };
        };

        // Request this from the view/controller
        this.getContainer = function () {
            if (_controller.getContainer) {
                // If the controller has fully set up...
                return _controller.getContainer();
            }
            // If the controller hasn't set up yet, and we need this (due a setup to error), send the container
            return container;
        };

        this.getMeta = this.getItemMeta = function () {
            return _itemMeta;
        };

        this.getPlaylistItem = function (index) {
            if (!utils.exists(index)) {
                return _controller._model.get('playlistItem');
            }
            var playlist = _this.getPlaylist();
            if (playlist) {
                return playlist[index];
            }
            return null;
        };

        this.getRenderingMode = function () {
            return 'html5';
        };

        this.load = function (toLoad) {
            var plugin = this.getPlugin('vast') || this.getPlugin('googima');
            if (plugin) {
                plugin.destroy();
            }
            _controller.load(toLoad);
            return _this;
        };

        this.play = function (state, meta) {
            if (!_.isBoolean(state)) {
                meta = state;
            }
            if (!meta) {
                meta = { reason: 'external' };
            }
            if (state === true) {
                _controller.play(meta);
                return _this;
            } else if (state === false) {
                _controller.pause();
                return _this;
            }

            state = _this.getState();
            // buffering的时候不让暂停，以解决一个bug，但根本原因也许不在这里，之后得再看下。zhangzhe 2016-06-29
            switch (state) {
                case states.PLAYING:
                    // case states.BUFFERING:
                    _controller.pause();
                    break;
                default:
                    _controller.play(meta);
            }

            return _this;
        };

        this.pause = function (state) {
            if (_.isBoolean(state)) {
                return this.play(!state);
            }

            return this.play();
        };

        this.createInstream = function () {
            return _controller.createInstream();
        };

        this.castToggle = function () {
            if (_controller && _controller.castToggle) {
                _controller.castToggle();
            }
        };

        // These may be overridden by ad plugins
        this.playAd = this.pauseAd = utils.noop;

        this.remove = function () {
            // Remove from array of players
            globalRemovePlayer(_this);

            // terminate state
            _this.trigger('remove');

            // Unbind listeners and destroy controller/model/...
            _reset();

            return _this;
        };

        return this;
    };

    return Api;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/api/api.js
 ** module id = 49
 ** module chunks = 0
 **/